module.exports = __webpack_public_path__ + "static/media/aqua4.335ee21a.jpg";